module.exports = __webpack_public_path__ + "img/content-img4_3.3fe72cb2.png";